import React from "react";
import { CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";
import { Container } from "./Elements/Section";
import { CTAButton } from "./Elements/CTAButton";
import { COLOR_ACCENT, COLOR_PRIMARY, LOGO_SRC } from "../config/Constants";

export const Hero = () => {
  return (
    <section
      id="home"
      className="relative isolate overflow-hidden"
      style={{
        background: `linear-gradient(180deg, ${COLOR_ACCENT}22, #ffffff 55%)`,
      }}
    >
      <Container>
        <div className="py-20 sm:py-28 lg:py-32 grid lg:grid-cols-2 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div
              className="inline-flex items-center gap-2 rounded-full border bg-white px-3 py-1 text-xs font-semibold"
              style={{ borderColor: COLOR_ACCENT, color: COLOR_PRIMARY }}
            >
              Cutting‑edge IT services for India & overseas
            </div>
            <h1 className="mt-4 text-4xl sm:text-5xl font-extrabold tracking-tight text-gray-900">
              We build world‑class products and platforms
            </h1>
            <p className="mt-4 text-lg text-gray-600 max-w-xl">
              From strategy to ship, our teams deliver secure, scalable software
              using modern stacks and proven delivery.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <CTAButton>Start a project</CTAButton>
              <a
                href="#work"
                className="inline-flex items-center gap-2 font-semibold text-gray-900"
              >
                See our work →
              </a>
            </div>
            <ul className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-4 text-sm text-gray-600">
              {[
                "ISO‑ready practices",
                "Timezone overlap",
                "Design → Dev → DevOps",
                "Secure SDLC",
                "Data & AI first",
                "Performance obsessed",
              ].map((t) => (
                <li className="flex items-center gap-2" key={t}>
                  <CheckCircle2 style={{ color: COLOR_ACCENT }} /> {t}
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="relative"
          >
            <div
              className="aspect-[4/3] rounded-3xl border bg-white shadow-xl overflow-hidden"
              style={{ borderColor: "#e5e7eb" }}
            >
              <div className="h-full w-full grid grid-cols-2">
                <div className="p-6 flex flex-col justify-between">
                  <div>
                    <h3 className="font-semibold text-gray-900">
                      Delivery at startup speed
                    </h3>
                    <p className="mt-2 text-sm text-gray-600">
                      Lean pods, weekly demos, measurable outcomes.
                    </p>
                  </div>
                  <div className="text-xs text-gray-500">
                    SLA‑backed. NPS‑driven.
                  </div>
                </div>
                <div
                  className="p-6 text-white"
                  style={{ background: COLOR_PRIMARY }}
                >
                  <h3 className="font-semibold">Cloud‑native by default</h3>
                  <ul className="mt-2 space-y-2 text-sm">
                    <li className="flex items-center gap-2">
                      <CheckCircle2 /> Kubernetes & IaC
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle2 /> Observability
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle2 /> Cost optimization
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </Container>
      <div className="absolute inset-0 -z-10 pointer-events-none flex items-start justify-end p-6">
        <img
          src={LOGO_SRC}
          alt="SKYENCE TECH Logo"
          className="opacity-10 w-40 h-40 object-contain"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </div>
    </section>
  );
};
